module.exports = __webpack_public_path__ + "images/emoji/triangular_ruler.8d385dabc056d57f43d8.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/triangular_ruler.png
// module id = CDCE
// module chunks = 14